import styled from 'styled-components'

export const InventorySliderPreviewStyled = styled.div`
    display: flex;
    flex-direction: column;
`

export const InventorySliderTitle = styled.div`
    text-align: center;
    font-weight: 500;
    color: #777777;
    font-size: 16px;
    line-height: 1.2;

    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-word;
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
    letter-spacing: 0px;
    line-height: 1.2;
    text-align: center;
`

export const InventorySlider = styled.div`
    width: min(85vw, 1000px);
    overflow: auto;

    display: flex;
    flex-direction: row;
    gap: 15px;
    padding: 10px 0;

    ::-webkit-scrollbar {
        height: 10px;
        width: 10px;
        background: #aaa;
        transition: all 0.5s ease-in-out;
    }

    ::-webkit-scrollbar-thumb {
        background: #393812;
    }

    ::-webkit-scrollbar-corner {
        background: #000;
    }

    &:hover {
        ::-webkit-scrollbar {
            height: 10px;
            width: 10px;
            background: #aaa;
            transition: all 0.5s ease-in-out;
        }
    }
`

export const InventorySliderImage = styled.div`
    width: 75px;
    height: 75px;
    flex-shrink: 0;
    border-radius: 5px;
    cursor: pointer;

    > * {
        border-radius: 5px;
    }
`
